import React from 'react';
import styled from 'styled-components';
import { Col, Row } from 'antd';
import { FormattedMessage } from 'react-intl';

import ContainerWrapper from 'Common/Components/ContainerWrapper';
import zReportDatev from 'assets/images/zreport-datev.png';

const SizeImg = styled.img`
  width: 100%;
  margin: 0 auto;
  display: block;
`;

const MissingSubPage: React.FC = () => (
  <ContainerWrapper
    css={`
      display: inline-block;
      padding: 1.5em 1em 3em;
      width: 100%;
    `}
    data-testid="missing-sub-page"
  >
    <Row
      justify="center"
      align="middle"
      css={`
        max-width: 1440px;
        margin: 0 auto;
      `}
    >
      <Col
        span={10}
        css={`
          padding: 0 20px;
        `}
      >
        <SizeImg src={zReportDatev} alt="zReport DATEV Inventorum" />
      </Col>
      <Col
        span={14}
        css={`
          padding: 20px;
        `}
      >
        <h2>
          <FormattedMessage
            defaultMessage="SHORE and DATEV Kassenarchiv online:{breakline} Automatically secure your transactions digitally"
            values={{ breakline: <br /> }}
          />
        </h2>

        <p>
          <FormattedMessage
            defaultMessage="Our new DATEV integration makes it possible to automatically submit your transactions to the new DATEV Kassenarchiv. All necessary data for the daily closing will automatically be created by Shore POS and transferred to accounting archive at DATEV,the predominant source of tax data for accountants. All stored data will be audit-proof as it cannot be changed after the fact. Plus, all files are stored in known formats so that the accountant can do the bookeeping fast and easy. Be one of the first to activate this feature. Our support is here to help at {breakline} <b>+49 30 208 98 6330</b> or <b>pos@shore.com</b>{breakline} {breakline} We’re happy to guide you through the setup and configuration. {breakline} Please be aware that <b>an existing DATEV account will be necessary</b> to activate this feature."
            values={{
              breakline: <br />,
              b: (m: React.ReactNode) => <b>{m}</b>,
            }}
          />
        </p>
      </Col>
    </Row>
  </ContainerWrapper>
);

export default MissingSubPage;
